import { render, staticRenderFns } from "./noPermissions.vue?vue&type=template&id=1fe8c60a"
import script from "./noPermissions.vue?vue&type=script&lang=js"
export * from "./noPermissions.vue?vue&type=script&lang=js"
import style0 from "./noPermissions.vue?vue&type=style&index=0&id=1fe8c60a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports